import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { PipesModule } from '@freelancer/pipes';
import { TrackingModule } from '@freelancer/tracking';
import { UiModule } from '@freelancer/ui';
import { UserProfileEditableUiModule } from '../../user-profile-editable-ui/user-profile-editable-ui.module';
import { UserProfileEducationsEditComponent } from './user-profile-educations-edit/user-profile-educations-edit.component';
import { UserProfileEducationsViewComponent } from './user-profile-educations-view/user-profile-educations-view.component';
import { UserProfileEducationsComponent } from './user-profile-educations.component';

@NgModule({
  imports: [
    CommonModule,
    UiModule,
    TrackingModule,
    PipesModule,
    UserProfileEditableUiModule,
  ],
  declarations: [
    UserProfileEducationsComponent,
    UserProfileEducationsViewComponent,
    UserProfileEducationsEditComponent,
  ],
  exports: [
    UserProfileEducationsComponent,
    UserProfileEducationsViewComponent,
    UserProfileEducationsEditComponent,
  ],
})
export class UserProfileEducationsModule {}
